module.exports = __webpack_public_path__ + "static/media/logo.e13f525c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 98
// module chunks = 0